import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const extratoRoutes: RouteRecordRaw[] = [
    {
        path: "/solicitacao",
        name: "solicitacao",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_IMPORTACAO_EXTRATO},
        component: () => import("@/modules/extrato/pages/PageSolicitacao.vue")
    },
    {
        path: "/extrato",
        name: "extrato",
        meta: {authRequired: true},
        component: () => import("@/modules/extrato/pages/PageExtrato.vue")
    },
    {
        path: "/conciliacao",
        name: "conciliacao",
        meta: {authRequired: true},
        component: () => import("@/modules/extrato/pages/PageConciliacao.vue")
    },
];
